import React from 'react';
import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  Button,
  HeaderText,
  Stack,
} from '../../../../ui';
import { NotificationsAlertCircleIcon } from '../../../../ui/Icons';

export type MissingPaymentInfoBannerProps = {
  providerId: number;
  planSelectionEnabled: boolean;
};

const MissingPaymentInfoBanner: React.FC<MissingPaymentInfoBannerProps> = ({
  providerId,
  planSelectionEnabled,
}) => (
  <Inline
    color={colors.redLite}
    paddingY={8}
    paddingX={16}
    borderBottomWidth={1}
    borderStyle="solid"
    borderColor={colors.red}
    space={12}
    testID="missingPaymentBanner"
  >
    <NotificationsAlertCircleIcon
      color={colors.whiteWash}
      backgroundColor={colors.red}
      borderColor={colors.red}
    />
    <Stack space={8}>
      <HeaderText level={2}>
        Clients can&apos;t book you
      </HeaderText>
      <Inline space={16}>
        <Button
          size="medium"
          link="provider.settings_menu.payments"
          linkParams={{
            providerId,
            beginOnboarding: true,
            clickSource: 'not_on_paments_banner',
          }}
          click-tracking="not_on_payments_banner_primary_cta_clicked"
          testID="not-on-payments-banner-primary-cta"
          appearance="link-lowercase"
        >
          Link Bank Account
        </Button>
        {planSelectionEnabled ? (
          <Button
            size="medium"
            link="provider.settings_menu.plan_selection"
            linkParams={{
              providerId,
              clickSource: 'not_on_paments_banner',
              initiatedFrom: 'not_on_paments_banner',
            }}
            click-tracking="not_on_payments_banner_secondary_cta_clicked"
            testID="not-on-payments-banner-secondary-cta"
            appearance="link-lowercase"
          >
            Don&apos;t use StyleSeat payments
          </Button>
        ) : null}
      </Inline>
    </Stack>
  </Inline>
);

export default MissingPaymentInfoBanner;
